import * as React from 'react'
import { IconButtonBase, IconButtonBaseProps } from './IconButtonBase'
import { Icon, IconProps } from '../Icon'

type IconButtonProps = IconButtonBaseProps & IconProps

export const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  label,
  labelColor,
  disabled,
  spinning,
  disableHover,
  children,
  icon,
  withBorder = true,
}) => {
  return (
    <IconButtonBase disabled={disabled} label={label} labelColor={labelColor} onClick={onClick}>
      <Icon
        icon={icon}
        withBorder={withBorder}
        disableHover={disableHover}
        spinning={spinning}
      />
      {children}
    </IconButtonBase>
  )
}
